import { useEffect, useMemo, useState } from 'react'
import Router from './router/Router'
import publicRoutes from './router/routes/publicRoutes'
import { getRoutes } from './router/routes'
import { useDispatch, useSelector } from 'react-redux'
import { get_user_info } from './store/Reducers/authReducer'
import { get_currencyIQD } from './store/Reducers/dashboardReducer'
import { socket } from './utils/utils'

function App() {
  const dispatch = useDispatch()
  const { userInfo, token } = useSelector((state) => state.auth)

  // build the full route set synchronously — no effect, no timing gap
  const allRoutes = useMemo(() => [...publicRoutes, getRoutes()], [])

  useEffect(() => {
    if (token) {
      dispatch(get_user_info())
    }
  }, [token, dispatch])

  useEffect(() => {
    dispatch(get_currencyIQD())
    const handleCurrencyUpdate = () => dispatch(get_currencyIQD())
    socket.on('currencyUpdate', handleCurrencyUpdate)
    return () => socket.off('currencyUpdate', handleCurrencyUpdate)
  }, [dispatch])

  return <Router allRoutes={allRoutes} />
}

export default App
